import styles from './style.module.scss';
import { Divider, Row, Col, Spin, Table, Checkbox } from 'antd';
import { Button, PageHeader } from 'components';
import { Link, useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useSingleInvoice from '../useSingleInvoice';

const Single = () => {
  const { t } = useTranslation();
  const { id: routeId } = useParams();
  const {
    loading,
    data,
    columns,
    tableSummary,
    pageTitle,
    isWeekClosed,
    canUpdate,
  } = useSingleInvoice();

  const showEdit = canUpdate !== false;

  return (
    <div>
      <PageHeader title={pageTitle}>
        <Checkbox checked={isWeekClosed} disabled>
          {t('Chiudere la settimana')}
        </Checkbox>
      </PageHeader>
      <div className={styles.content}>
        <Spin spinning={loading}>
          <Table
            columns={columns}
            dataSource={data}
            pagination={false}
            size='small'
            summary={tableSummary}
            rowKey='id'
            scroll={{ x: 1000 }}
          />
        </Spin>
        <Divider />
        <Row gutter={16}>
          {showEdit && (
            <Col>
              <Button>
                <Link to={`/finance/blank-invoices/${routeId}/edit`}>
                  {t('MODIFICA')}
                </Link>
              </Button>
            </Col>
          )}
          <Col>
            <Button type={'secondary'}>
              <Link to={'/finance/blank-invoices'}>{t('TORNA INDIETRO')}</Link>
            </Button>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default Single;
